import * as helpersDate from './date-helpers'
import * as helpersSayi from './sayi-helpers'
import * as helpersString from './string-helpers'

export const filters = {
  ...helpersDate,
  ...helpersSayi,
  ...helpersString,
}

export default filters
